import {
    useState,
    useCallback,
    useEffect,
} from 'react';
import {
    webLibSdk,
    formatPrice,
    findPercentageOfTwo,
    getFormatterAllocationType,
} from 'helpers';
import { CUSTOM_ALLOCATION_TYPE } from '_constants/allocationTypes';
import toastAlert from 'components/UI/Alert';

const ONE_BILLION = 1000000000;

const useTableData = (distributionAllocationType) => {
    const [rows, setRows] = useState();

    const columns = useCallback(() => ([
        {
            name: 'Distribution',
            selector: (row) => (<span className="row-label">{getFormatterAllocationType(row.type)}</span>),
            width: '200px',
        },
        {
            name: '% of FTN',
            selector: (row) => `${findPercentageOfTwo(row.totalAmount, ONE_BILLION)}%`,
            center: true,
        },
        {
            name: 'Total',
            selector: (row) => `${formatPrice(row.totalAmount)} FTN`,
            center: true,
        },
        {
            name: 'Available',
            selector: (row) => `${formatPrice(row.availableAmount)} FTN`,
            center: true,
        },
    ]), []);

    const getRows = async () => {
        try {
            const types = await webLibSdk[distributionAllocationType === CUSTOM_ALLOCATION_TYPE ? 'customDistributionProperties' : 'allocationTypes']();

            if (distributionAllocationType === CUSTOM_ALLOCATION_TYPE) {
                setRows([{
                    type: 'Custom Sale',
                    totalAmount: types.balance,
                    availableAmount: types.balance - types.allocatedAmount,
                }]);
                return;
            }

            setRows(types);
        } catch (err) {
            toastAlert({
                type: 'error',
                customMessage: err,
            });
            console.error('Error getting table rows:', err);
        }
    };

    useEffect(() => {
        getRows();
    }, [distributionAllocationType]);

    return {
        data: {
            columns: columns(),
            rows,
        },
        mutation: getRows,
    };
};

export default useTableData;
